import type { TabItem } from '../../components/common/TabBar/TabBar';

export type OrchestratorTabKey = 'treinos' | 'fup';

export type OrchestratorTab = TabItem & {
  key: OrchestratorTabKey;
  icon: string;
};

export const ORCHESTRATOR_TABS: OrchestratorTab[] = [
  { key: 'treinos', label: 'Ciclos de treino', icon: 'exercise' },
  { key: 'fup', label: 'FUP CN', icon: 'chat' },
];

export const getOrchestratorTabPath = (key: OrchestratorTabKey): string => (
  key === 'fup' ? '/orquestrador/fup' : '/orquestrador'
);
